import React, { useState } from "react";

function statusLabel(status) {
  if (status === "OK") return "OK";
  if (status === "NON_OK") return "NON OK";
  if (status === "NA") return "N.A.";
  return "Da fare";
}

export default function PanicStepCard({ step, row, saving, onSave, onNonOk, onNext, isLast }) {
  const [valueText, setValueText] = useState(row?.value_text || "");
  const status = row?.status || "PENDING";
  const moduleLinks = Array.isArray(step.moduleLinks) && step.moduleLinks.length > 0
    ? step.moduleLinks
    : step.modulePath
      ? [{ path: step.modulePath, label: step.moduleLabel }]
      : [];

  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div>
          <div className="text-xs font-semibold uppercase tracking-wide text-slate-500">
            Priorita {step.level} - Step {step.priority + 1}
          </div>
          <h1 className="mt-1 text-2xl font-bold text-slate-950">{step.title}</h1>
        </div>
        <div className="rounded-full border border-slate-200 bg-slate-50 px-3 py-1 text-sm font-semibold text-slate-700">
          {statusLabel(status)}
        </div>
      </div>

      <p className="mt-5 text-xl font-semibold leading-snug text-slate-900">{step.instruction}</p>

      {step.objective && (
        <div className="mt-4 rounded-2xl border border-amber-200 bg-amber-50 p-4">
          <div className="text-xs font-semibold uppercase tracking-wide text-amber-700">Obiettivo ispettivo</div>
          <div className="mt-1 text-sm font-medium text-amber-950">{step.objective}</div>
        </div>
      )}

      {Array.isArray(step.checklist) && step.checklist.length > 0 && (
        <div className="mt-4 rounded-2xl border border-slate-200 bg-slate-50 p-4">
          <div className="text-xs font-semibold uppercase tracking-wide text-slate-500">Da controllare</div>
          <div className="mt-3 space-y-2">
            {step.checklist.map((item) => (
              <div key={item} className="flex items-start gap-3 text-sm text-slate-800">
                <span className="mt-1 inline-block h-2.5 w-2.5 rounded-full bg-slate-900" />
                <span>{item}</span>
              </div>
            ))}
          </div>
        </div>
      )}

      {moduleLinks.length > 0 && (
        <div className="mt-5 flex flex-wrap gap-2">
          {moduleLinks.map((link) => (
            <a
              key={`${step.id}-${link.path}-${link.label}`}
              href={link.path}
              target="_blank"
              rel="noreferrer"
              className="rounded-xl border border-slate-300 bg-white px-4 py-2 text-sm font-semibold hover:bg-slate-50"
            >
              {link.label}
            </a>
          ))}
        </div>
      )}

      <label className="mt-5 block">
        <span className="text-xs font-semibold text-slate-500">Nota rapida o valore</span>
        <textarea
          className="mt-1 min-h-[96px] w-full rounded-xl border border-slate-300 px-3 py-2 text-sm"
          value={valueText}
          onChange={(event) => setValueText(event.target.value)}
          placeholder={step.valuePlaceholder || "Salva solo cio che serve. Puoi continuare anche con nota vuota."}
        />
      </label>

      <div className="mt-5 grid grid-cols-1 gap-2 sm:grid-cols-4">
        <button
          type="button"
          disabled={saving}
          onClick={() => onSave("OK", valueText)}
          className="rounded-xl bg-emerald-600 px-4 py-3 text-sm font-bold text-white hover:bg-emerald-700 disabled:opacity-60"
        >
          OK
        </button>
        <button
          type="button"
          disabled={saving}
          onClick={() => onNonOk(valueText)}
          className="rounded-xl bg-red-600 px-4 py-3 text-sm font-bold text-white hover:bg-red-700 disabled:opacity-60"
        >
          NON OK
        </button>
        <button
          type="button"
          disabled={saving}
          onClick={() => onSave("NA", valueText)}
          className="rounded-xl border border-slate-300 px-4 py-3 text-sm font-bold hover:bg-slate-50 disabled:opacity-60"
        >
          N.A.
        </button>
        <button
          type="button"
          disabled={saving}
          onClick={onNext}
          className="rounded-xl border border-slate-300 px-4 py-3 text-sm font-bold hover:bg-slate-50 disabled:opacity-60"
        >
          {isLast ? "Riepilogo" : "Avanti"}
        </button>
      </div>
    </div>
  );
}
